import script from "./FooterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterView.vue?vue&type=script&lang=ts&setup=true"

import "./FooterView.vue?vue&type=style&index=0&id=9733668c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9733668c"]])

export default __exports__